<template>
  <footer class="footer-main-holder">
    <svg class="footer-svg"></svg>
    <div class="footer-inner" :class="{ padded: slug !== undefined }">
      <div class="footer-top">
        <router-link
          :to="
            $i18nRoute({ name: 'MainWrapper', params: { category: 'feed' } })
          "
        >
          Zamon
        </router-link>
      </div>
      <div class="footer-middle">
        <div class="middle-item middle-item-categories">
          <div class="header">{{ $t("main.categories") }}</div>
          <nav class="cat-items-holder">
            <router-link
              :to="
                $i18nRoute({
                  name: 'MainWrapper',
                  params: { category: item.slug }
                })
              "
              v-for="(item, index) in categories"
              :key="index"
              class="cat-item"
            >
              {{ item[`name_${i18n.global.locale._value}`] }}
            </router-link>
          </nav>
          <div class="right-border"></div>
          <div class="bottom-border"></div>
        </div>
        <div class="middle-item middle-item-contacts">
          <div class="header">{{ $t("main.contacts") }}</div>
          <div class="contact-item">
            <span style="font-size: 1.4em; padding-right: 0.375em">
              <i class="fas fa-phone-alt"></i>
            </span>
            <a href="tel:+998 (90) 777-77-77">+998 (90) 777-77-77</a>
            <span style="padding: 0 0.4em" class="none">|</span>
            <a href="tel:+998 (90) 777-77-77" class="none"
              >+998 (90) 777-77-77</a
            >
          </div>
          <div class="contact-item">
            <span style="font-size: 1.4em; padding-right: 0.375em">
              <i class="far fa-at"></i>
            </span>
            <a
              class="no-bold"
              href="mailto:info@zamon.uz"
              style="font-weight: bold"
              >info@zamon.uz</a
            >
          </div>
          <div class="contact-item">
            <span style="font-size: 1.5em; padding-right: 0.375em">
              <i class="fas fa-map-marker-alt"></i>
            </span>
            <a
              rel="nofollow noopener "
              target="_blank"
              href="https://goo.gl/maps/LZ2S2G5veLgBd7Kb7"
              class="contact-meta adaptive-375"
              >г.Ташкент, проспект Амира Темура 53</a
            >
          </div>
          <div class="right-border"></div>
          <div class="bottom-border"></div>
        </div>
        <div class="middle-item middle-item-info">
          <div class="header">{{ $t("main.information") }}</div>
          <div class="contact-item">
            {{ $t("footer.disclaimer_text") }} Zamon.uz
          </div>
          <div class="contact-item">
            {{ $t("footer.founder") }}: ООО "Master Media Production and
            Broadcast"
          </div>
          <div class="contact-item">
            {{ $t("footer.certificate") }}: №1346
            {{ $t("footer.date_issued") }}: 28.05.2020
          </div>
          <div class="right-border"></div>
          <div class="bottom-border"></div>
        </div>
      </div>
      <div class="footer-bottom">
        <a
          href="https://twitter.com/zamon_uz"
          target="_blank"
          rel="noopener noreferrer"
          class="soc-net-holder"
          title="Twitter"
        >
          <i class="fab fa-twitter soc-net"></i>
        </a>
        <a
          href="https://www.facebook.com/zamontv/"
          target="_blank"
          rel="noopener noreferrer"
          class="soc-net-holder"
          title="Facebook"
        >
          <i class="fab fa-facebook-f soc-net"></i>
        </a>
        <a
          href="https://t.me/zamonuz"
          rel="noopener noreferrer"
          target="_blank"
          class="soc-net-holder"
          title="Telegram"
        >
          <i class="fab fa-telegram-plane soc-net"></i>
        </a>
        <a
          href="https://www.instagram.com/zamon.uz/?igshid=7pq6rzpavqgb"
          target="_blank"
          rel="noopener noreferrer"
          class="soc-net-holder"
          title="Instagram"
        >
          <i class="fab fa-instagram soc-net"></i>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useLanguage } from "../utils/language";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const store = useStore();

    return {
      categories: computed(() => store.getters.categories),
      ...useLanguage(),
      slug: computed(() => route.params.slug)
    };
  }
};
</script>

<style lang="scss" scoped>
@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
  .footer-main-holder {
    background-color: rgba(var(--primary-bg), 0.6);
  }
}

.footer-main-holder {
  width: 100%;
  backdrop-filter: blur(8px);
  background-color: rgba(var(--primary-bg), 0.7);
  position: relative;
  z-index: 27;
  display: flex;

  .footer-svg {
    display: none;
  }

  .footer-inner {
    width: var(--main-wrapper-width);
    position: relative;
    z-index: 31;
    border-top: 1px solid var(--foreground-color);
    margin: 0 auto;
    padding-bottom: 3.125rem;

    &.padded {
      margin-left: 260px;
      margin-right: 20px;
      width: 100%;
    }

    .footer-top {
      width: 100%;
      text-align: center;
      font-family: Playfair Display SC;
      display: flex;
      justify-content: center;
      font-weight: 500;
      font-size: 5.625em;
    }

    .footer-middle {
      padding-top: 3rem;
      display: flex;
      flex-wrap: wrap;

      .middle-item {
        min-width: 420px;
        max-width: 100%;
        flex: 1 0 0;
        position: relative;
        height: auto;
        min-height: 215px;
        padding-left: 25px;

        &:last-child {
          flex-grow: 2;

          .right-border {
            display: none;
          }
        }

        &:first-child {
          padding-left: 0;

          .bottom-border {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 90%;
            height: 1px;
            background-color: var(--foreground-color);
            transform: none;
          }
        }

        .header {
          font-family: Open Sans;
          font-weight: bold;
          font-size: 1.375em;
          padding-bottom: 1.625rem;
          text-transform: capitalize;
        }

        .right-border {
          position: absolute;
          top: 0;
          right: 0;
          width: 1px;
          height: 90%;
          background-color: var(--foreground-color);
        }

        .bottom-border {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          height: 1px;
          background-color: var(--foreground-color);
        }

        .contact-item {
          font-size: 1.125em;
          display: flex;
          align-items: center;
          padding-bottom: 1.25rem;

          .contact-meta {
            width: 84%;
            line-height: 1.75em;
          }
        }

        .cat-items-holder {
          display: flex;
          width: 100%;
          flex-wrap: wrap;

          .cat-item {
            font-family: Open Sans;
            font-size: 1.25em;
            line-height: 1.375em;
            padding-right: 1rem;
            margin-bottom: 1.625rem;
            cursor: pointer;
            transition: all 0.4s ease;

            &::after {
              content: "|";
              padding-left: 1rem;
            }

            &:last-child {
              &::after {
                content: "";
                padding: 0;
              }
            }

            &:hover {
              opacity: 0.7;
            }
          }
        }
      }
    }

    .footer-bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 2rem;

      .soc-net-holder {
        width: 62px;
        height: 62px;
        // background-color: var(--background-color);
        // transition: all 0.4s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        cursor: pointer;
        margin: 0 1.7rem;

        &:hover {
          // background-color: var(--foreground-color);

          .soc-net {
            opacity: 1;
          }
        }

        .soc-net {
          transition: all 0.4s ease;
          fill: var(--foreground-color);
          opacity: 0.7;
          font-size: 2.25rem;
        }
      }
    }
  }
}

@media screen and (min-width: 1605px) {
  .footer-main-holder {
    .footer-inner {
      .footer-middle {
        .middle-item {
          &:first-child {
            padding-left: 0;

            .bottom-border {
              position: absolute;
              bottom: 0;
              left: 0;
              width: calc(100% - 25px);
              height: 1px;
              background-color: var(--foreground-color);
              transform: none;
            }
          }

          &:last-child {
            .bottom-border {
              right: 0;
              left: unset;
              width: calc(100% - 25px);
              height: 1px;
              background-color: var(--foreground-color);
              transform: none;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1604px) {
  .middle-item-info {
    text-align: center;
    min-width: 450px !important;
    max-width: 100%;
    padding-left: 0em !important;
    margin-top: 15px;
    .header {
      margin-right: 23px;
    }
    .contact-item {
      display: block;
      justify-content: center;
    }
  }
  .middle-item-contacts {
    .right-border {
      display: none;
    }
    .bottom-border {
      left: 54% !important;
    }
  }
}

@media screen and (max-width: 1366px) {
  .footer-main-holder {
    .footer-inner {
      &.padded {
        margin-left: 260px;
      }
    }
  }
}

@media screen and (max-width: 1081px) {
  .middle-item {
    min-width: 300px !important;
    max-width: 100%;
    min-height: auto !important;

    .cat-item {
      padding-right: 0.6rem !important;
    }
    .cat-item::after {
      padding-left: 0.6rem !important;
    }
  }

  .middle-item-info {
    text-align: center;
    min-width: 360px !important;
    max-width: 100%;
    padding-left: 0em !important;
    margin-top: 20px;

    .header {
      margin-right: 23px;
    }
    .contact-item {
      display: block;
      justify-content: center;
    }
  }

  .middle-item-contacts {
    .right-border {
      display: none;
    }
    .bottom-border {
      left: 54% !important;
    }
  }
}

@media screen and (max-width: 992px) {
  .footer-main-holder {
    .footer-inner {
      &.padded {
        width: var(--main-wrapper-width);
        margin: 0 auto;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .footer-main-holder {
    .footer-inner {
      &.padded {
        width: var(--main-wrapper-width);
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
}

@media screen and (max-width: 775px) {
  .none {
    display: none;
  }

  .footer-main-holder {
    display: flex;
    justify-content: center;

    .footer-svg {
      display: block;
      width: 10em;
      height: 15em;
      background-image: url("../assets/i-footer.svg");
      background-repeat: no-repeat;
      position: absolute;
      bottom: 5em;
      left: 50%;
      transform: translateX(-50%);
    }

    .footer-top {
      font-size: 4em !important;
    }

    .footer-middle {
      padding-top: 1.5em !important;
      flex-direction: column;
    }

    .middle-item {
      min-height: auto !important;
      padding-bottom: 10px;

      .header {
        display: none;
      }

      .cat-items-holder {
        justify-content: center !important;

        .cat-item {
          font-weight: 600;
          line-height: 1.5em;
        }
      }

      .right-border {
        width: 175px !important;
        height: 2px !important;
        top: auto !important;
        bottom: 0 !important;
      }

      .bottom-border {
        width: 175px !important;
        height: 2px !important;
      }

      .middle-item-categories {
        min-width: none;
      }
    }
    .middle-item-contacts {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-top: 25px;
      padding-left: 0px !important;

      .no-bold {
        font-weight: normal !important;
      }

      .right-border {
        display: unset;
        right: 50px;
      }

      .bottom-border {
        left: 85px !important;
      }

      .contact-item {
        min-width: 200px;
        justify-content: center;
        .contact-meta {
          width: 100% !important;
          text-align: center;
        }
      }
    }
    .middle-item-info {
      padding-top: 10px;

      .contact-item {
        line-height: 2em;
        font-size: 1.3em !important;
      }

      .bottom-border {
        display: none;
      }
    }

    .footer-bottom {
      display: none;
    }
  }
}

@media screen and (max-width: 490px) {
  .footer-main-holder {
    .footer-top {
      font-size: 4em;
    }

    .footer-middle {
      padding-top: 1.5em;

      .middle-item {
        min-width: auto !important;
        min-height: auto;
        padding-bottom: 10px;

        .header {
          display: none;
        }

        .right-border {
          width: 130px;
          height: 2px;
          top: auto;
          bottom: 0;
          right: 0px;
        }
        .bottom-border {
          width: 130px;
          height: 2px;
        }

        .middle-item-categories {
          min-width: none;

          .cat-items-holder {
            justify-content: center;

            .cat-item {
              font-weight: 600;
              line-height: 1.5em;
              padding-right: 0.8em !important;

              &::after {
                padding-left: 0.8em !important;
              }
            }
          }
        }

        .middle-item-contacts {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          margin-top: 25px;
          padding-left: 0px;

          .contact-item {
            min-width: 200px;
            justify-content: center;
          }
          .bottom-border {
            left: 0px;
          }
        }

        .middle-item-info {
          padding-top: 10px;

          .contact-item {
            line-height: 2em;
            font-size: 1.3em;
          }

          .bottom-border {
            display: none;
          }
        }
      }
    }

    .footer-bottom {
      display: none !important;
    }
  }
}

@media screen and (max-width: 385px) {
  .footer-middle {
    padding-top: 1.25em;

    .footer-svg {
      bottom: 2em;
    }

    .footer-top {
      font-size: 3em;
    }

    .middle-item {
      padding-bottom: 0px;
    }

    .middle-item-categories {
      .right-border {
        height: 1px;
      }

      .bottom-border {
        height: 1px;
      }

      .cat-items-holder {
        justify-content: center;
        .cat-item {
          line-height: 1.3em;
          padding-right: 1.1em;
          &::after {
            display: none;
          }
        }
      }
    }

    .middle-item-contacts {
      .right-border {
        height: 1px;
      }

      .bottom-border {
        height: 1px;
      }

      .contact-item {
        min-width: 140px;
        font-size: 1.05em;
      }

      .adaptive-375 {
        width: 100%;
      }
    }
    .middle-item-info {
      .contact-item {
        line-height: 1.5em;
        font-size: 1.1em;
      }
    }
  }
}
</style>
